export const on = (root, event, selector, handler, options) => {
    root.addEventListener(event, (e) => {
      const el = e.target.closest(selector);
      if (el && root.contains(el)) handler(e, el);
    }, options);
  };